import RcSlider from 'rc-slider'

interface AdvancedSliderProps {
  value: number
  onChange: (value: number) => void
  /** Slider step size. Default: 0.01 */
  step?: number
  /** Decimal precision for display. Default: 2 */
  precision?: number
}

function AdvancedSlider(props: AdvancedSliderProps) {
  const { value, onChange, step = 0.01, precision = 2 } = props

  return (
    <div className={cls`relative pb-3 pt-6`}>
      <span
        className={cls`cover-advanced-slider-value text-f-text-secondary pointer-events-none absolute top-0 z-[2] -translate-x-1/2 text-base`}
        style={{ left: `${value * 100}%` }}
      >
        {value.toFixed(precision)}
      </span>
      <div className={cls`relative h-7`}>
        <div
          className={cls`bg-f-bg-active absolute inset-x-0 top-1/2 h-2.5 -translate-y-1/2 rounded-full`}
        />
        <div
          className={cls`bg-f-primary absolute left-0 top-1/2 h-2.5 -translate-y-1/2 rounded-full`}
          style={{ width: `${value * 100}%` }}
        />
        <span
          className={cls`bg-f-text pointer-events-none absolute top-1/2 z-[2] flex size-5 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full shadow-[0_4px_10px_rgba(0,0,0,0.24)]`}
          style={{ left: `${value * 100}%` }}
        >
          <span className={cls`bg-f-primary size-3 rounded-full`} />
        </span>
        <RcSlider
          prefixCls='ant-slider'
          min={0}
          max={1}
          step={step}
          value={value}
          onChange={(nextValue) => onChange(nextValue as number)}
          className={cls`cover-advanced-slider absolute inset-0 z-[3] m-0 cursor-pointer opacity-0`}
          styles={{
            rail: {
              height: 26,
              background: 'transparent',
            },
            track: {
              height: 26,
              background: 'transparent',
            },
            handle: {
              width: 28,
              height: 28,
              marginTop: 0,
              border: 'none',
              background: 'transparent',
              boxShadow: 'none',
              opacity: 0,
            },
          }}
        />
      </div>
    </div>
  )
}

export default AdvancedSlider
